import config from '@/assets/js/config'
import Crypto from './Crypto.js'
import uploadWebEvent from './UploadWebEvent.js'
import translate from './Translate.js'
import { post } from './Axios.js'
// import AppInfo from '../../appInfo/index'

export function changeTitle () {
  // 不同的页面要修改为不同内容
  // document.title = translate('title')
  // document.title = AppInfo.getfirstUpperCaseAppName() + ' ' + translate('Sign in')
}

// 浏览器语言
export function browserLanguage () {
  let lang = (window.navigator.language || window.navigator.browserLanguage).toLowerCase()
  let language = 'en-US'
  if (lang === 'zh-cn') {
    language = 'zh-CN'
  } else if (lang === 'zh-hk' || lang === 'zh-mo' || lang === 'zh-tw') {
    language = 'zh-hant'
  } else if (lang === 'es') {
    language = 'es–ES'
  } else if (lang === 'ru') {
    language = 'ru–RU'
  }
  return language
};

// 检测登录设备是pc还是手机
export function checkDevice () {
  let ua = navigator.userAgent
  let isWindowsPhone = /(?:Windows Phone)/.test(ua)
  let isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone
  let isAndroid = /(?:Android)/.test(ua)
  let isFireFox = /(?:Firefox)/.test(ua)
  let isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua))
  let isPhone = /(?:iPhone)/.test(ua) && !isTablet
  let isPc = !isPhone && !isAndroid && !isSymbian
  return isPc
};

export function checkWX () {
  return /micromessenger/.test(navigator.userAgent.toLowerCase())
};

export function checkIsChrome () {
  let ua = navigator.userAgent
  // check pc.
  if (checkDevice() && ua.indexOf('Chrome') > -1) return true
  // check mobile device.
  // eslint-disable-next-line no-useless-escape
  let chromeReg = new RegExp('\\bCrMo\\b|CriOS|Android.*Chrome\/[.0-9]* (Mobile)?', 'i')
  return chromeReg.test(ua)
};

export function isTablet () {
  let ua = navigator.userAgent
  let isAndroid = /(?:Android)/.test(ua)
  let isFireFox = /(?:Firefox)/.test(ua)
  return /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua))
}

// 判断输入是否为空
export function checkEmpty (data) {
  if (data === '') {
    return false
  } else {
    return true
  }
};

// 检测账号逻辑
export function checkInputAccount (account, callback, type, status) {
  if (checkEmail(account)) { // 判断输入的是不是邮箱，是邮箱则直接到下一步
    if (config.type === 'newInvite') {
      // 埋点统计：首页_开始安全通信 邮箱
      uploadWebEvent('REGISTER', {
        type: 0,
        result: status
      })
    }
    return true
  } else if (/^[0-9]*$/.test(account)) { // 不是邮箱的情况下，判断是不是纯数字，纯数字即认为是手机号
    if (checkPhone(account)) {
      if (config.type === 'newInvite') {
        // 埋点统计：首页_开始安全通信 手机号
        uploadWebEvent('REGISTER', {
          type: 1,
          result: status
        })
      }
      return true
    } else { // 纯数字且长度不满足手机号规则的，错误提示
      if (config.isLogin) {
        // 埋点统计：首个页面输入框手机号不合法
        uploadWebEvent('INVALID_PHONE', {
          type
        })
      } else if (config.type === 'invite') {
        // 埋点统计：首个页面输入框手机号不合法
        uploadWebEvent('INVITE_INVALID_PHONE', {
          type
        })
      }
      if (config.type === 'newInvite') {
        // 埋点统计：首页_开始安全通信 输入框手机号不合法
        uploadWebEvent('START', {
          type: 2
        })
      }
      callback('INVALID_PHONE')
      return false
    }
  } else { // 不是邮箱也不是纯数字的情况下，认为是账号
    if (checkUsername(account)) {
      if (config.type === 'newInvite') {
        // 埋点统计：首页_开始安全通信 用户名
        uploadWebEvent('REGISTER', {
          type: 2,
          result: status
        })
      }
      return true
    } else {
      if (config.isLogin) {
        // 埋点统计：首个页面输入框用户名不合法
        uploadWebEvent('INVALID_USERNAME', {
          type
        })
      } else if (config.type === 'invite') {
        // 埋点统计：首个页面输入框用户名不合法
        uploadWebEvent('INVITE_INVALID_USERNAME', {
          type
        })
      }
      if (!/^[a-zA-Z0-9_-]+$/.test(account)) {
        if (config.type === 'newInvite') {
          // 埋点统计：首页_开始安全通信 用户名包含特殊字符
          uploadWebEvent('START', {
            type: 4
          })
        }
        callback('INVALID_USERNAME_2')
        return false
      } else if (!/^[a-zA-Z]{6,20}$/.test(account)) {
        if (config.type === 'newInvite') {
          // 埋点统计：首页_开始安全通信 用户名不以字母开始
          uploadWebEvent('START', {
            type: 3
          })
        }
        callback('INVALID_USERNAME_1')
        return false
      }
    }
  }
};

// 检测邮箱格式
export function checkEmail (data) {
  let emailReg = /^[A-Za-z0-9!#$%&'+/=?^_`{|}~-]+((\\-[A-Za-z0-9!#$%&'+/=?^_`{|}~-]+)|(\.[A-Za-z0-9!#$%&'+/=?^_`{|}~-]+))*@[\u4e00-\u9fa5_a-zA-Z0-9]+((\.|\\-)[\u4e00-\u9fa5_a-zA-Z0-9]+)*.[a-zA-Z0-9]+$/
  if (emailReg.test(data)) {
    return true
  } else {
    return false
  }
}

// 检测手机格式
export function checkPhone (data) {
  let phoneReg = /^([\d]{5,20})$/
  if (phoneReg.test(data)) {
    return true
  } else {
    return false
  }
};

// 检测用户名格式
export function checkUsername (data) {
  let accountReg = /^[a-zA-Z][a-zA-Z0-9_-]{5,19}$/
  if (accountReg.test(data)) {
    return true
  } else {
    return false
  }
};

// 获取路由
export function getLocationHash () {
  return location.hash
};

// 获取publickey
export function getPublicKey (account) {
  return localStorage.getItem(account + '_publickey') || ''
};

// 获取md5
export function getMD5 (value) {
  let crypto = new Crypto()
  return crypto.getMD5(value)
};

export function savePwd (obj, password) {
  let crypto = new Crypto()
  let md5 = crypto.getMD5(obj['public_key']) || getPublicKey(obj['account'])
  let pwd = crypto.aesEncrypt(md5, password || obj['password'])
  localStorage.setItem('sipPwd', pwd)
}

// 邀请页重定向跳转
let inviteRedirectFlag = true
export function inviteRedirect (that) {
  if (location.href.indexOf('token=') > 0) {
    if (location.href.length - location.href.indexOf('#/') === 2) {
      inviteRedirectFlag = false
      let href = location.href.substring(0, location.href.indexOf('#/'))
      let arr = href.split('?')
      href = arr[0] + '#/?' + arr[1]
      location.href = href
    }
  } else {
    that.$router.push({path: '/invite/inviteerror'})
  }
};

// 获取邀请页title
let inviteTitle = ''
let inviteName = ''
let inviteGroup = ''
let inviteTeam = ''
let inviteType = 1
export async function getInviteTitle (that) {
  if (inviteTitle === '' && inviteRedirectFlag) {
    // 埋点统计：打开页面
    uploadWebEvent('VIEW', {
      type: checkWX()
    })
    let params = {
      invite_token: that.$route.query['token'],
      language: browserLanguage()
    }
    let callback = function (msg, status) {
      if (status !== '0') {
        that.$router.push({path: '/invite/inviteerror'})
      } else {
        openApp(that.$route.query['token'])
      }
    }
    let res = await post('/proxy-api/client/web/index/verify-share-token-new', params, callback)
    // if (res.data.payload.type === 0) {
    //   inviteTitle = translate('inviteTitle0', res.data.payload.inviter, res.data.payload.app_name)
    // } else if (res.data.payload.type === 1) {
    //   inviteTitle = translate('inviteTitle1', res.data.payload.inviter, res.data.payload.dept)
    // } else if (res.data.payload.type === 3) {
    //   inviteTitle = translate('inviteTitle3', res.data.payload.group)
    // } else if (res.data.payload.type === 4) {
    //   inviteTitle = translate('Welcome to Crait')
    // }
    if (res.data.payload.type === 0) {
      inviteTitle = translate('newInviteTitle0', res.data.payload.inviter, res.data.payload.app_name)
    } else if (res.data.payload.type === 1) {
      inviteTitle = translate('newInviteTitle1', res.data.payload.inviter, res.data.payload.dept)
      inviteType = 3
    } else if (res.data.payload.type === 3) {
      inviteTitle = translate('newInviteTitle3', res.data.payload.group)
      inviteType = 2
    } else if (res.data.payload.type === 4) {
      inviteTitle = translate('Welcome to Crait')
    }
    inviteName = res.data.payload.inviter
    inviteGroup = res.data.payload.group
    inviteTeam = res.data.payload.dept
  }
  return inviteTitle
}

export function getInviteName () {
  return inviteName
}

export function getInviteGroup () {
  return inviteGroup
}

export function getInviteType () {
  return inviteType
}
export function getInviteTeam () {
  return inviteTeam
}

let oldUserName = ''
export function addOldUserName (name) {
  oldUserName = name
}

export function getInviteTitle2 () {
  return 'Crait用户“' + oldUserName + '”您好，请输入密码以接受邀请'
}

// 判断如果本地已经安装了app，则打开app
function openApp (token) {
  if (navigator.userAgent.indexOf('Android') > -1) {
    let url = 'batchatnew://?cmd=login&token=' + token
    let iframe = document.createElement('iframe')
    let body = document.body
    iframe.style.cssText = 'display:none;width=0;height=0'
    body.appendChild(iframe)
    iframe.src = url
    if (navigator.userAgent.indexOf('Chrome') > -1) {
      location.href = url
    }
  }
}

// 路由之间传递数据
export let transferData = {
  data: {},
  saveData (data) {
    this.data = data
  },
  getData () {
    return JSON.parse(JSON.stringify(this.data))
  },
  deleteData () {
    this.data = {}
  }
}

// indify code get max time.
export const MaxTimeOut = 59

export const accountType = {
  PHONE_TYPE: 1,
  EMAIL_TYPE: 2
}



// WEBPACK FOOTER //
// ./src/new-login-2018/common/Common.js